export default __webpack_public_path__ + "static/pack_mobile-f04d21f6e0a445aca8720e240b8f3ddb.png";